import React, { useEffect, useState, Suspense } from 'react';
import { connect, useDispatch } from "react-redux";
import ReactPixel from 'react-facebook-pixel';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import 'antd/dist/antd.css';
import { notification } from 'antd';
import { getCurrencies } from './redux/actions/currencies';
import { getUser } from './redux/actions/user';
import { getMerchantData } from './redux/actions/merchantData';
import { getTransactionNotification, setSocketNewNotification } from "./redux/actions/transactions";
import './App.scss';
import ScrollToTop from './components/ScrollToTop';
import AuthPagesWrapper from './pages/AuthPagesWrapper/AuthPagesWrapper';
import LayoutWrapper from './layout/LayoutWrapper';
import Home from './pages/Home';
import Merchants from './pages/Merchants';
import MerchantEdit from './pages/MerchantEdit';
import MerchantWallets from './pages/MerchantWallets';
import AdminMerchantsWallets from './adminPanel/components/AdminMerchantsWallets';
import WalletsPage from './pages/WalletsPage';
import WalletsNewPage from './pages/WalletsNewPage';
import ClientsPage from './pages/ClientsPage';
import ClientsNewPage from './pages/ClientsNewPage';
import MerchantClientsPage from './pages/MerchantClientsPage';
import AdminClientsPage from './adminPanel/pages/UserAccounts/AdminClientsPage';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import Withdraw from './pages/Withdraw';
import Swap from './pages/Swap';
import SwapNew from './pages/SwapNew';
import NftWallet from './pages/NftWallet';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import LoginOptions from './components/LoginOptions';
import SignUpOptions from './components/SignUpOptions';
import NewPasswordForm from './components/NewPasswordForm/NewPasswordForm';
import PublicRoute from './components/PublicRoute/PublicRoute';
import SendPasswordForm from './components/SendPasswordForm/SendPasswordForm';
import ResetPasswordForm from './components/ResetPasswordForm/ResetPasswordForm';
import EmailVerification from './components/EmailVerification/EmailVerification';
import Notifications from './components/Notifications/Notifications';
import VersionOverlay from './components/VersionOverlay/VersionOverlay';
import Support from './pages/Support';
import PageNotFound from './components/PageNotFound/PageNotFound';
import CheckoutsPage from './pages/CheckoutsPage';
import CheckoutCreator from './pages/CheckoutCreator';
import CheckoutPaymentPage from './pages/CheckoutPaymentPage';
import SaleTokenPaymentPage from './pages/SaleTokenPaymentPage';
import SaleTokenCreator from './pages/SaleTokenCreator';
import WelcomeModal from './components/WelcomeModal';
import ReleaseNotesModal from './components/ReleaseNotes/Modal';
import { hotjar } from 'react-hotjar';
import DeletedCharge from './pages/DeletedCharge';
import { getMerchants } from './redux/actions/merchants';
// ADMIN COMPONENTS
import AdminLayoutWrapper from './adminPanel/layout/LayoutWrapper';
import AdminDashboard from './adminPanel/pages/Dashboard';
import AdminSettings from './adminPanel/pages/Settings';
import AdminUsers from './adminPanel/pages/Users';
import AdminUserEdit from './adminPanel/pages/UserEdit';
import AdminUserMerchants from './adminPanel/pages/UserMerchants';
import AdminUserAccounts from './adminPanel/pages/UserAccounts';
import AdminFeeWallets from './adminPanel/pages/FeeWallets';
import AdminWithdraw from './adminPanel/pages/Withdraw';
import AdminTransactions from './adminPanel/pages/Transactions';
import EmailChangeVerify from './components/EmailChangeVerify/EmailChangeVerify';
import TransactionsByUser from './adminPanel/pages/TransactionsByUser';
import PriceChart from './adminPanel/pages/PriceChart';
import { identity } from './utils/getIdentity';
import { NftSupportProvider } from './utils/nftSupportContext';

// Login check for SEO
import WelcomeUser from './pages/WelcomeUser';
import TransactionsHistory from './pages/TransactionsHistory';
import { AppConfig } from "./config";
import { Helmet } from "react-helmet";
import SubscriptionsPage from "./pages/SubscriptionsPage";
import ActivitiesPage from "./pages/ActivitiesPage";
import LoginHistoryPage from "./pages/LoginHistoryPage";
import AdminSwap from "./pages/AdminSwap";
import AdminSwapHistory from "./pages/AdminSwapHistory";
import moment from "moment";
import AddressBook from "./pages/AddressBook";

function App({ sessionData, isShowWelcomeModal, getUser, merchantId, getCurrencies, getMerchantData, getMerchants, getTransactionNotification }) {
  const [socket, setSocket] = useState(undefined);
  const [storedValue, setStoredValue] = useState(JSON.parse(localStorage.getItem('wizzardShow')) ?? true);
  const [storedValueInex, setStoredValueInex] = useState(JSON.parse(localStorage.getItem('wizzardShowInex')) ?? true);

  const dispatch = useDispatch();

  const hideWizzardBlock = () => {
    localStorage.setItem('wizzardShow', false);

    setStoredValue(false);
  };

  const loadLocale = async (locale) => {
    switch (locale) {
      case 'es':
        await import('moment/locale/es');
        break;
      default:
        await import('moment/locale/en-gb');
        break;
    }
    moment.locale(locale);
  };

  const language = localStorage.getItem('cpayAppLang');

  useEffect(() => {
    loadLocale();
  }, [language])

  const hideWizzardBlockInex = () => {
    localStorage.setItem('wizzardShowInex', false);

    setStoredValueInex(false);
  }

  useEffect(() => {
    document.documentElement.style.setProperty('--main-color', AppConfig.identity === 'inex' ? '#FF6D23' : AppConfig.identity === 'finvaro' ? '#BBD7FF' : '#CD081E');
    document.documentElement.style.setProperty('--bg-color', AppConfig.identity === 'inex' ? '#2D2E2B' : '#FFFFFF');
    document.documentElement.style.setProperty('--light-color', AppConfig.identity === 'inex' ? '#f2d5c7' : '#e6f7ff');
    document.documentElement.style.setProperty('--secondary-color', AppConfig.identity === 'inex' ? '#FFFFFF' : '#000000');
    document.documentElement.style.setProperty('--secondary-color-text', AppConfig.identity === 'inex' ? '#FFFFFF' : 'rgba(0, 0, 0, 0.65)');
    document.documentElement.style.setProperty('--secondary-color-notif', AppConfig.identity === 'inex' ? '#FF6D23' : 'rgba(0, 0, 0, 0.65)');
    document.documentElement.style.setProperty('--bg-sec-color', AppConfig.identity === 'inex' ? '#343632' : '#FFFFFF');
    document.documentElement.style.setProperty('--bg-hover', AppConfig.identity === 'inex' ? '#343632' : '#e8e8e8');
    document.documentElement.style.setProperty('--border', AppConfig.identity === 'inex' ? '#80827E' : '#d9d9d9');
    document.documentElement.style.setProperty('--swap', AppConfig.identity === 'inex' ? '#2D2E2B' : '#f3f4f5');
    document.documentElement.style.setProperty('--bg-admin', AppConfig.identity === 'inex' ? '#2D2E2B' : '#f0f2f5');
    document.documentElement.style.setProperty('--pagination', AppConfig.identity === 'inex' ? '#FF6D23' : '#CD081E');
    document.documentElement.style.setProperty('--date-border', AppConfig.identity === 'inex' ? '#FF6D23' : '#CD081E');
    document.documentElement.style.setProperty('--date-background', AppConfig.identity === 'inex' ? '#fcf1eb' : '#e6f7ff');
    document.documentElement.style.setProperty('--date-color', AppConfig.identity === 'inex' ? '#FF6D23' : '#CD081E');
    document.documentElement.style.setProperty('--modal-header', AppConfig.identity === 'inex' ? '#2D2E2B' : 'rgba(0, 135, 252, 0.06)');
    document.documentElement.style.setProperty('--body-background', AppConfig.identity === 'inex' ? '#2D2D2C' : '#f1f3f6');
    document.documentElement.style.setProperty('--scroll-background', AppConfig.identity === 'inex' ? '#2D2E2B' : '#fafafa');
    document.documentElement.style.setProperty('--scroll-thumb', AppConfig.identity === 'inex' ? '#80827E' : '#888');
    document.documentElement.style.setProperty('--date-hover', AppConfig.identity === 'inex' ? '#FF6D23' : '#e6f7ff');
  }, []);

  useEffect(() => {
    if (process.env.REACT_APP_HOTJAR_ID && process.env.REACT_APP_HOTJAR_VERSION) {
      hotjar.initialize(process.env.REACT_APP_HOTJAR_ID, process.env.REACT_APP_HOTJAR_VERSION);
    }

    if (process.env.REACT_APP_FACEBOOK_PIXEL) {
      ReactPixel.init(process.env.REACT_APP_FACEBOOK_PIXEL);
      ReactPixel.pageView();
    }
  }, []);

  useEffect(() => {
    if (sessionData) {
      getUser();
      getCurrencies();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData]);

  useEffect(() => {
    if (window?.google) {
      // global google
      const google = window.google;
      google.accounts.id.initialize({
        client_id: process?.env.REACT_APP_GOOGLE_CLIENT,
        // callback: loginByGoogle
      });
    }
  }, []);

  const getNotification = () => {
    getTransactionNotification(merchantId, { page: 1 });
  }

  useEffect(() => {
    socket && socket.disconnect();
    setSocket(undefined);
    createSocket(merchantId);
  }, [merchantId]);

  useEffect(() => {
    if (merchantId) {
      getNotification();
    }
  }, [merchantId]);

  const createSocket = merchantId => {
    const io = window.io;
    const socket = io(process.env.REACT_APP_API_URL, {
      allowEIO3: true,
      withCredentials: true,
    });
    if (merchantId) {
      let socketStatus;
      socket.on('connect', () => {
        socket.emit('sign-in-merchant', { token: localStorage.getItem('authToken'), merchantId });
        setSocket(socket);
      });

      socket.on('confirmedTransaction', data => {
        if (merchantId) {
          socketStatus = data?.systemStatus;

          if (socketStatus === 'Error' || socketStatus === 'Failed') {
            notification.error({
              message: data?.systemStatus || 'Error',
              description: (
                <span style={{ whiteSpace: 'initial', wordWrap: 'break-word' }}>
                  {data?.errorMessage ? data?.errorMessage : 'Error'}
                </span>
              ),
            });
            return;
          }
        }
      });

      socket.on('transactionNewNotification', () => {
        dispatch(setSocketNewNotification());

        getNotification();
      })

      socket.on('confirmedTransactionHash', data => {
        if (merchantId) {
          if (data.type !== 'SystemFee' && socketStatus !== 'Error' && socketStatus !== 'Failed') {
            notification.success({
              message: 'Successful transaction',
              description: (
                <div>
                  {
                    <div style={{ height: '100%' }}>
                      <h3 style={{ fontSize: '14px', color: '#818A98', marginBottom: '-3px' }}>Hash:</h3>
                      <a
                        href={`${data.explorerUrl}`}
                        rel="noopener noreferrer"
                        target="_blank"
                        style={{ color: '#CD081E', whiteSpace: 'initial', wordWrap: 'break-word', cursor: 'pointer' }}
                      >
                        {data.explorerUrl}
                      </a>
                    </div>
                  }
                </div>
              ),
              duration: 8,
            });
          }
        }
      });
    }
  };

  return (
    <BrowserRouter basename={AppConfig.identity === 'clarnium' ? '/pay' : ''}>
    <NftSupportProvider>
    {AppConfig.identity === 'cpay' && (
      <Helmet>
        <link rel="icon" href="/cpay-icons/favicon.ico" type="image/x-icon" />
      </Helmet>
    )}

    {AppConfig.identity === 'nfg' && (
      <Helmet>
        <link rel="icon" href="/nfgpay-icons/favicon.ico" type="image/x-icon" />
      </Helmet>
    )}

    {AppConfig.identity === 'finvaro' && (
      <Helmet>
        <link rel="icon" href="/finvaro-icons/favicon.ico" type="image/x-icon" />
      </Helmet>
    )}

    {AppConfig.identity === 'clarnium' && (
      <Helmet>
        <link rel="icon" href="/clarnium-icons/favicon.ico" type="image/x-icon" />
      </Helmet>
    )}

    {AppConfig.identity === 'insta' && (
      <Helmet>
        <link rel="icon" href="/instaXchange-icons/favicon.ico" type="image/x-icon" />
      </Helmet>
    )}

    <Suspense fallback={null}>
      <Notifications />
        <ScrollToTop />
        {AppConfig?.showReleaseNotes && <ReleaseNotesModal sessionData={sessionData} isShowWelcomeModal={isShowWelcomeModal} />}
        {!AppConfig?.hideLogo && <VersionOverlay />}
        <Switch>
          <Route exact path="/support">
            <AuthPagesWrapper childComponent={Support} withWelcomeBlock={false} />
          </Route>

          <Route exact path="/checkout/:identifier">
            <CheckoutCreator />
          </Route>

          <Route exact path="/charge/:chargeId">
            <CheckoutPaymentPage />
          </Route>

          <Route exact path="/sale-token-checkout/:identifier">
            <SaleTokenCreator />
          </Route>

          <Route exact path="/subscriptions">
            <LayoutWrapper>
              <SubscriptionsPage />
            </LayoutWrapper>
          </Route>

          <Route exact path="/activities">
            <LayoutWrapper>
              <ActivitiesPage />
            </LayoutWrapper>
          </Route>

          <Route exact path="/sale-token-charge/:chargeId">
            <SaleTokenPaymentPage />
          </Route>

          <Route exact path="/charge-not-found">
            <DeletedCharge />
          </Route>

          <Route exact path="/user/email/verify/:key">
            <AuthPagesWrapper childComponent={EmailVerification} withWelcomeBlock={false} />
          </Route>

          <PrivateRoute exact path="/">
            <LayoutWrapper storedValue={storedValue} storedValueInex={storedValueInex} hideWizzardBlock={hideWizzardBlock} hideWizzardBlockInex={hideWizzardBlockInex}>
              <Home storedValue={storedValue} storedValueInex={storedValueInex} />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/welcome-user">
            <LayoutWrapper>
              <WelcomeUser />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/registration-completed">
            {isShowWelcomeModal ? (
              <LayoutWrapper>
                <WelcomeModal />
                <Home />
              </LayoutWrapper>
            ) : (
              <Redirect to="/" />
            )}
          </PrivateRoute>

          <PrivateRoute exact path="/merchants">
            <LayoutWrapper>
              <Merchants />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/merchants/edit/:merchantId">
            <LayoutWrapper>
              <MerchantEdit />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/merchants/wallets/:merchantId">
            <LayoutWrapper>
              <MerchantWallets />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/admin/merchants/wallets/:userId/:merchantId">
            <AdminLayoutWrapper>
              <AdminMerchantsWallets />
            </AdminLayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/admin/merchants/clients/:userId/:merchantId">
            <AdminLayoutWrapper>
              <AdminClientsPage />
            </AdminLayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/wallets">
            <LayoutWrapper>
              <WalletsPage />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/wallets-new">
            <LayoutWrapper>
              <WalletsNewPage />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/merchants/clients/:merchantId">
            <LayoutWrapper>
              <MerchantClientsPage />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/clients">
            <LayoutWrapper>
              <ClientsPage />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/clients-new">
            <LayoutWrapper>
              <ClientsNewPage />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/profile">
            <LayoutWrapper>
              <Profile />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/settings">
            <LayoutWrapper>
              <Settings />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/withdraw">
            <LayoutWrapper>
              <Withdraw />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/address-book">
            <LayoutWrapper>
              <AddressBook />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/multisend">
            <LayoutWrapper>
              <Withdraw />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/nft-wallet">
            <LayoutWrapper>
              <NftWallet />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/swap">
            <LayoutWrapper>
              <Swap />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/swap/create">
            <LayoutWrapper>
              <SwapNew />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/swap/create/swing">
            <LayoutWrapper>
              <SwapNew />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/checkouts">
            <LayoutWrapper>
              <CheckoutsPage getMerchantData={getMerchantData} getMerchants={getMerchants} />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/recurring-billing">
            <LayoutWrapper>
              <CheckoutsPage getMerchantData={getMerchantData} getMerchants={getMerchants} />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/transactions">
            <LayoutWrapper>
              <TransactionsHistory />
            </LayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/admin/settings">
            <AdminLayoutWrapper>
              <AdminSettings />
            </AdminLayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/admin/price-chart">
            <AdminLayoutWrapper>
              <PriceChart />
            </AdminLayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/admin">
            <AdminLayoutWrapper>
              <AdminDashboard />
            </AdminLayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/admin/users">
            <AdminLayoutWrapper>
              <AdminUsers />
            </AdminLayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/admin/user-edit/:userId">
            <AdminLayoutWrapper>
              <AdminUserEdit />
            </AdminLayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/admin/user-fees/:userId">
            <AdminLayoutWrapper>
              <AdminUserMerchants />
            </AdminLayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/admin/user-accounts/:userId">
            <AdminLayoutWrapper>
              <AdminUserAccounts />
            </AdminLayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/admin/wallets">
            <AdminLayoutWrapper>
              <AdminFeeWallets />
            </AdminLayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/admin/withdraw">
            <AdminLayoutWrapper>
              <AdminWithdraw />
            </AdminLayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/admin/swap-history">
            <AdminLayoutWrapper>
              <AdminSwapHistory />
            </AdminLayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/admin/swap">
            <AdminLayoutWrapper>
              <AdminSwap />
            </AdminLayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/admin/swap/create">
            <AdminLayoutWrapper>
              <SwapNew type="admin" />
            </AdminLayoutWrapper>
          </PrivateRoute>

          {identity === 'cpay' && (
            <PrivateRoute exact path="/admin/swap/create/:stable">
              <AdminLayoutWrapper>
                <SwapNew type="admin" />
              </AdminLayoutWrapper>
            </PrivateRoute>
          )}

          <PrivateRoute exact path="/admin/transactions">
            <AdminLayoutWrapper>
              <AdminTransactions />
            </AdminLayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/admin/user-transactions/:userId">
            <AdminLayoutWrapper>
              <TransactionsByUser />
            </AdminLayoutWrapper>
          </PrivateRoute>

          <PrivateRoute exact path="/admin/login-history/:userId">
            <AdminLayoutWrapper>
              <LoginHistoryPage />
            </AdminLayoutWrapper>
          </PrivateRoute>

          <PublicRoute exact path="/login">
            <AuthPagesWrapper childComponent={LoginOptions} withWelcomeBlock={true} />
          </PublicRoute>

          {identity !== 'finvaro' && (
            <PublicRoute exact path="/sign-up">
              <AuthPagesWrapper childComponent={SignUpOptions} withWelcomeBlock={true} />
            </PublicRoute>
          )}

          <PublicRoute exact path="/password-send">
            <AuthPagesWrapper childComponent={SendPasswordForm} withWelcomeBlock={true} />
          </PublicRoute>

          <PublicRoute exact path="/password-reset">
            <AuthPagesWrapper childComponent={ResetPasswordForm} withWelcomeBlock={true} />
          </PublicRoute>

          <Route exact path="/user/changeEmail/verify/:token">
            <AuthPagesWrapper childComponent={EmailChangeVerify} />
          </Route>

          <PublicRoute exact path="/forgotten/verify/:token">
            <AuthPagesWrapper childComponent={NewPasswordForm} withWelcomeBlock={true} />
          </PublicRoute>

          <Route component={PageNotFound} />
        </Switch>
    </Suspense>
    </NftSupportProvider>
    </BrowserRouter>
  );
}

const mapStateToProps = state => ({
  sessionData: state.login.data,
  isShowWelcomeModal: state.user.showWelcomeModal,
  merchantId: state.transactions.merchantId,
});

const mapDispatchToProps = dispatch => ({
  getUser: getUser(dispatch),
  getCurrencies: getCurrencies(dispatch),
  getMerchantData: getMerchantData(dispatch),
  getMerchants: getMerchants(dispatch),
  getTransactionNotification: getTransactionNotification(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
